import { HTTP_STATUS } from '@blockit/std/http';
import { Toaster } from '@blockit/ui/sonner';
import { HrefLink } from '@blockit/web-shared/router/HrefLink';
import { RouterLinkProvider } from '@blockit/web-shared/ui/routerLink';
import { ErrorFallback } from '@components/ErrorFallback';
import { ErrorBoundary } from '@datadog/browser-rum-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { AxiosError } from 'axios';
import { router } from '@/router';

import '@/styles/tailwind.css';

const MAX_QUERY_RETRIES = 3;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (
          error instanceof AxiosError &&
          (error.response?.status === HTTP_STATUS.NOT_FOUND || error.response?.status === HTTP_STATUS.BAD_REQUEST)
        ) {
          return false;
        }
        return failureCount < MAX_QUERY_RETRIES;
      },
    },
  },
});

export const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary fallback={ErrorFallback}>
        {/* `expand`: Sonner collapses the stack to the newest toast by default; every toast stays visible.
              `visibleToasts`: Sonner's default is 3 and it does not queue the overflow — hidden toasts keep
              running their dismissal timers and close unseen (its timer effect does not depend on
              visibility), so the cap is set to the five the app has always shown.
              `theme='system'`: Sonner hard-codes the description colour per its own theme attribute, so it
              has to track the OS scheme itself for descriptions to stay readable on a dark popover. */}
        <Toaster position='bottom-right' expand visibleToasts={5} theme='system' />
        <RouterLinkProvider value={HrefLink}>
          <RouterProvider router={router} />
        </RouterLinkProvider>
      </ErrorBoundary>
    </QueryClientProvider>
  );
};
